export default __webpack_public_path__ + "static/media/jsFramework.911c595a.svg";